/**
 * AUTO-GENERATED — DO NOT EDIT
 *
 * Generated by tools/gen-sqlite-from-db-schema.ts
 * To regenerate, run: pnpm powersync:schema:generate
 */

import { sqliteTable, text } from 'drizzle-orm/sqlite-core';

export const patientEncounters = sqliteTable('patient_encounters', {
  id: text('id').primaryKey().notNull(),
  org_id: text('org_id'),
  clinic_id: text('clinic_id'),
  patient_id: text('patient_id'),
  visit_id: text('visit_id'),
  queue_id: text('queue_id'),
  appointment_id: text('appointment_id'),
  provider_id: text('provider_id'),
  type: text('type'),
  status: text('status'),
  chief_complaint: text('chief_complaint'),
  consult_started_at: text('consult_started_at'),
  consult_ended_at: text('consult_ended_at'),
  started_at: text('started_at'),
  ended_at: text('ended_at'),
  closed_by: text('closed_by'),
  closure_reason: text('closure_reason'),
  created_at: text('created_at'),
  updated_at: text('updated_at'),
  updated_by: text('updated_by'),
});
